import { FilterData } from 'app/models/businesses/Filters.model';

export class DeletePathFilter {
  static readonly type = '[Filters] DeletePathFilter';
  constructor(
    public filter: FilterData
  ) {}
}

export class InitFilters {
  static readonly type = '[Filters] InitFilters';
  constructor(
    public path: string
  ) {}
}

export class SetPathFilter {
  static readonly type = '[Filters] SetPathFilter';
  constructor(
    public filter: FilterData
  ) {}
}

export class UpdateFilters {
  static readonly type = '[Filters] UpdateFilters';
  constructor(
    public list: FilterData
  ) {}
}
